'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { closeCloneRequestModal as closeCloneRequestModalAction } from 'ContentEditorUI/redux/actions/moduleActions';
import { getActionForCloneRequest, getTypeForCloneRequest } from 'ContentEditorUI/redux/selectors/cloneRequestSelectors';
import { getIsAdvancedPageTemplate } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import { MODULE, ROW, COLUMN, SECTION } from 'ContentEditorUI/constants/cloneTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  actionForClone: getActionForCloneRequest(state),
  isAdvancedTemplate: getIsAdvancedPageTemplate(state),
  typeForClone: getTypeForCloneRequest(state)
});
const mapDispatchToProps = dispatch => ({
  dispatch,
  closeCloneRequestModal: () => dispatch(closeCloneRequestModalAction())
});
class CloneRequestModalContainer extends Component {
  constructor(props) {
    super(props);
    this.handleCancelClone = this.handleCancelClone.bind(this);
    this.handleConfirmClone = this.handleConfirmClone.bind(this);
  }
  handleCancelClone() {
    this.props.closeCloneRequestModal();
  }
  handleConfirmClone() {
    const {
      actionForClone,
      closeCloneRequestModal,
      dispatch
    } = this.props;
    if (actionForClone) {
      dispatch(actionForClone);
      closeCloneRequestModal();
    }
  }
  render() {
    const {
      actionForClone,
      isAdvancedTemplate,
      typeForClone
    } = this.props;
    if (!actionForClone) {
      return null;
    }
    const cloneModalDialogKey = isAdvancedTemplate ? `app.layoutSection.cloneDialogBody.${typeForClone}` : `app.layoutSection.cloneDialogBody.simpleTemplate.${typeForClone}`;
    return /*#__PURE__*/_jsx(UIConfirmModal, {
      confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.layoutSection.cloneDialogConfirmButton"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: cloneModalDialogKey
      }),
      rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.layoutSection.cloneDialogRejectButton"
      }),
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.layoutSection.cloneDialogTitle"
      }),
      onConfirm: this.handleConfirmClone,
      onReject: this.handleCancelClone
    });
  }
}
CloneRequestModalContainer.propTypes = {
  actionForClone: PropTypes.object,
  closeCloneRequestModal: PropTypes.func.isRequired,
  dispatch: PropTypes.func,
  isAdvancedTemplate: PropTypes.bool,
  typeForClone: PropTypes.oneOf([MODULE, ROW, COLUMN, SECTION])
};
export default connect(mapStateToProps, mapDispatchToProps)(CloneRequestModalContainer);